<script setup lang="ts">
// "Каждое утро — одна карта." — three real deck cards hanging on threads, face down;
// tap one to turn it over (RitualCard).
import { onBeforeUnmount, onMounted, ref } from 'vue';
import RitualCard from './RitualCard.vue';
import ScrollReveal from '@/components/ui/animation/ScrollReveal.vue';

// imgKey = the deck card index (cards/NN.webp): 17 The Star,
// 19 The Sun, 02 The High Priestess — matching the roman numerals shown.
const cards = [
  { imgKey: '17', name: 'Звезда', line: 'Надежда возвращается.', delay: 0 },
  { imgKey: '19', name: 'Солнце', line: 'Тёплый день впереди.', delay: 0.5 },
  { imgKey: '02', name: 'Жрица', line: 'Доверься интуиции.', delay: 1 },
];

// Off screen, the hanging cards hold still (client-only, after hydration).
const sectionEl = ref<HTMLElement | null>(null);
const offscreen = ref(false);
let io: IntersectionObserver | null = null;
onMounted(() => {
  if (!sectionEl.value || typeof IntersectionObserver === 'undefined') return;
  io = new IntersectionObserver(([entry]) => {
    offscreen.value = !entry.isIntersecting;
  });
  io.observe(sectionEl.value);
});
onBeforeUnmount(() => io?.disconnect());
</script>

<template>
  <section
    id="ritual"
    ref="sectionEl"
    :class="['relative scroll-mt-20 overflow-hidden py-16 md:py-24', offscreen && 'is-offscreen']"
  >
    <div
      class="site-container grid grid-cols-1 items-center gap-12 md:grid-cols-2 md:gap-10"
    >
      <ScrollReveal :delay="0">
        <div class="type-overline mb-4 text-primary-ink">
          Ежедневный ритуал
        </div>
        <h2 class="type-display">
          Каждое утро<br />— одна <em class="text-primary-ink">карта</em>.
        </h2>
        <p class="mt-5 max-w-[380px] text-[17px] leading-relaxed text-muted-foreground">
          Маленький ритуал перед телефоном в постели. Вытяни карту дня — и пусть кот подскажет, с чем ты сегодня просыпаешься.
        </p>
      </ScrollReveal>

      <ScrollReveal :delay="80">
        <div class="ml-auto grid max-w-[460px] grid-cols-3 gap-5 pt-10">
          <RitualCard
            v-for="(c, i) in cards"
            :key="i"
            :img-key="c.imgKey"
            :name="c.name"
            :line="c.line"
            :delay="c.delay"
          />
        </div>
        <p class="ml-auto mt-2 max-w-[460px] text-center text-xs text-muted-foreground">
          Нажми на любую карту 🐾
        </p>
      </ScrollReveal>
    </div>
  </section>
</template>

<style scoped>
.is-offscreen :deep(*) {
  animation-play-state: paused !important;
}
</style>
